var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit18(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "iconografia/18/edit-18") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconografia/18/edit-18",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.341,1.669 C15.9579659,1.2533697 15.4220882,1.0117914 14.857,1 L14.851,1 C14.2893297,1.02083199 13.7551465,1.24839403 13.351,1.639 L2.15,12.819 L1,17 L5.133,15.788 L16.307,4.632 C16.7180715,4.24742138 16.9660858,3.71989886 17,3.158 C17.001468,2.59066337 16.7619156,2.04939858 16.341,1.669 Z M4.5,14.728 L2.722,15.249 L3.222,13.44 L13.122,3.558 L14.407,4.841 L4.5,14.728 Z M15.481,3.767 L15.252,4 L13.967,2.713 L14.198,2.482 C14.3789409,2.31601009 14.6102174,2.21533267 14.855,2.196 C15.1017698,2.21086354 15.3318106,2.32570336 15.492,2.514 C15.6743539,2.66587869 15.7861165,2.88614861 15.801,3.123 C15.7749945,3.3690897 15.6614281,3.59764206 15.481,3.767 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit18);
export default __webpack_public_path__ + "static/media/edit-18.d6a9b1a4f8edc3372f95ff5005dba891.svg";
export { ForwardRef as ReactComponent };